exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-history-modal-message td {\n  text-align: left;\n}\n.customer-history-modal-message .date {\n  font-weight: bold;\n  white-space: nowrap;\n}\n.customer-history-modal-message .creator {\n  white-space: nowrap;\n}\n.customer-history-modal-message .time-from-now {\n  font-weight: normal;\n  font-style: italic;\n}\n.customer-history-modal-message .time-from-now:first-letter {\n  text-transform: uppercase;\n}", ""]);

// exports
